export default __webpack_public_path__ + "static/media/b46.2e65a6eb.png";